import type { SigninRequirements } from '@sine/sine-core-api-types';

export function isZonesRequired(siteRequirements: SigninRequirements): boolean {
  return !!siteRequirements.zonesEnabled;
}
